<template lang="pug">
  footer#footer.footer.navbar
    ul.footer_nav
      li.footer_navItem
        router-link.footer_navLink(to="/") Home
      li.footer_navItem
        router-link.footer_navLink(to="/numbers3") Numbers3 
      li.footer_navItem
        router-link.footer_navLink(to="/numbers4") Numbers4 
      li.footer_navItem
        router-link.footer_navLink(to="/loto6") Loto6 
      li.footer_navItem
        router-link.footer_navLink(to="/loto7") Loto7
      li.footer_navItem
        router-link.footer_navLink(to="/history") 履歴 
      li.footer_navItem
        router-link.footer_navLink(to="/terms") Terms
    .copy IXA.tokyo&copy;2019

</template>

<script>
export default {
  name: 'GlobalFooter',
  computed: {
    isAgree(){
      return this.$store.getters["ixa/getAgree"]
    }
  }
}
</script>

<style scoped lang="stylus">
#footer
  position: fixed 
  bottom: 0
  width: 100%
  display: block!important
  padding: 0!important
  background-color: #FFF
  .footer_nav
    display: flex
    flex-direction: row
    justify-content: center
    .footer_navItem
      display: block
      margin-right: 0.5rem
      margin-left: 0.5rem
      .footer_navLink
        lihe-height: 2em
        font-size: 0.7rem
      &.secret
        opacity: 0
  .copy
    text-align: center
    line-height: 1.7em
    font-size: 0.8rem
    margin-bottom: 7px
</style>
